import SuperAdminLayout from "SuperAdmin/SuperAdminLayout/SuperAdminLayout"
import SettingsNav from "SuperAdmin/SuperAdminNav/SettingsNav"



const ForgotPasswordPageSettings = () =>{
    return<>
    <SuperAdminLayout>

        <SettingsNav />

        <h1> Forgot Password Page Settings</h1>


    </SuperAdminLayout>
    
    </>
}
export default ForgotPasswordPageSettings